/**
 * Checks if value is classified as a Function object.
 * @param value The value to check.
 * @returns Returns true if value is a function, else false.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isFunction = value => typeof value === "function";

export { isFunction as default };
